import formatDuration from '@/services/utils/formatDuration';
import formatName from '@/services/utils/formatName';
import {
  CallSplit,
  Groups,
  Groups3,
  Numbers,
  Person4,
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useRouteLoaderData } from 'react-router-dom';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const forwardingTypes = {
  CFU: 'Dauerhafte Weiterleitung',
  CFB: 'Weiterleitung bei besetzt',
  CFNR: 'Weiterleitung bei Nichterreichbarkeit',
  NONE: 'Weiterleitung durch Modul',
  TRANSFER: 'Transfer durch User',
  BLINDTRANSFER: 'Blindtransfer durch User',
  CFI: 'Direkte Weiterleitung',
};

function getStatus(item) {
  if (!item.online) return 'offline';
  if (item.dnd) return 'nicht stören';
  if (item.busy) return 'besetzt';
  if (item.ringing) return 'klingelt bereits';
  return 'verfügbar';
}

export default function CallFlowItem({ data, call, next }) {
  const { users } = useRouteLoaderData('auth');
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <Card
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        {data.calledType === 'UNKNOWN' && call.outgoing && (
          <Typography
            sx={{
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
              color: data.pickup && 'success.main',
            }}
          >
            <Numbers sx={{ fontSize: '16px', mr: 0.5 }} />
            Externe Nummer
          </Typography>
        )}
        {data.calledType === 'UNKNOWN' && !call.outgoing && (
          <Typography
            sx={{
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
              color: data.pickup && 'success.main',
            }}
          >
            <Numbers sx={{ fontSize: '16px', mr: 0.5 }} />
            Unbekanntes Ziel
          </Typography>
        )}
        {data.calledType === 'USER' && (
          <Typography
            sx={{
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
              color: data.pickup && 'success.main',
            }}
          >
            <Person4 sx={{ fontSize: '16px', mr: 0.5 }} />
            Angerufener User
          </Typography>
        )}
        {data.calledType === 'GROUP' && (
          <Typography
            sx={{
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
              color: data.pickup && 'success.main',
            }}
          >
            <Groups3 sx={{ fontSize: '16px', mr: 0.5 }} />
            Angerufene Gruppe
          </Typography>
        )}
        {data.calledType === 'MODULE' && (
          <Typography
            sx={{
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
              color: data.pickup && 'success.main',
            }}
          >
            <CallSplit sx={{ fontSize: '16px', mr: 0.5 }} />
            Angerufenes Modul
          </Typography>
        )}
        <Typography sx={{ fontSize: '14px' }}>
          {data.calledName || data.calledNumber}
        </Typography>
        {call?.pickup && data.calledType === 'GROUP' && data.pickup && (
          <Typography sx={{ fontSize: '14px' }}>
            angenommen von : {call?.pickupFirstName} {call?.pickupLastName}
          </Typography>
        )}
        {next?.forwardType && (
          <Typography sx={{ fontSize: '14px' }}>
            {forwardingTypes[next.forwardType]}
          </Typography>
        )}
        {call.callbackRequested && (
          <Typography sx={{ fontSize: '14px' }}>
            Es wurde ein Rückruf gewünscht.
          </Typography>
        )}
      </Box>
      <Chip
        label={
          formatDuration(
            (new Date(data.timeEnd) - new Date(data.timeStart)) / 1000,
          ) || '0s'
        }
      />
      {!call.outgoing &&
        data.agentInfo?.length > 0 &&
        data.calledType !== 'MODULE' && (
          <Box>
            <Button
              startIcon={<Groups />}
              variant="outlined"
              size="small"
              sx={{ ml: 2 }}
              disableRipple
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              {data.agentInfo?.length} User
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={!!anchorEl}
              onClose={() => setAnchorEl(null)}
            >
              {data.agentInfo?.map((item) => (
                <ListItem dense key={item.accountId}>
                  <ListItemAvatar>
                    <Avatar
                      src={
                        !item.ringing
                          ? users.find(
                              (user) => user.starfaceId == item.accountId,
                            )?.profilePicture
                          : undefined
                      }
                    >
                      {!!item.ringing && <NotificationsActiveIcon />}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={formatName(
                      users.find((user) => user.starfaceId == item.accountId),
                    )}
                    secondary={getStatus(item)}
                  />
                </ListItem>
              ))}
            </Menu>
          </Box>
        )}
    </Card>
  );
}
